export default __webpack_public_path__ + "static/media/koi.81cd375d.png";